import { useState } from "react";
import "./index.css";

function LoginPage({ onSignIn, onSignUp, error, success}) {
  // State for login form
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPass, setLoginPass] = useState("");
  const [loginErrors, setLoginErrors] = useState({});
  // State for signup form
  const [signupFirstName, setSignupFirstName] = useState("");
  const [signupLastName, setSignupLastName] = useState("");
  const [signupUsername, setSignupUsername] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [signupSchool, setSignupSchool] = useState("");
  const [signupMajor, setSignupMajor] = useState("");
  const [signupGradYear, setSignupGradYear] = useState("");
  const [signupErrors, setSignupErrors] = useState({});
  const [showSignup, setShowSignup] = useState(false);

  function handleLoginSubmit(e) {
    e.preventDefault();
    const errs = {};
    if (!loginEmail || !/^\S+@\S+\.\S+$/.test(loginEmail)) {
      errs.loginEmail = true;
    }
    if (!loginPass) {
      errs.loginPass = true;
    }
    setLoginErrors(errs);
    if (Object.keys(errs).length === 0) {
      onSignIn(loginEmail, loginPass);
    }
  }

  function handleSignUpSubmit(e) {
    e.preventDefault();
    const errs = {};
    if (!signupFirstName.trim()) {
      errs.signupFirstName = true;
    }
    if (!signupLastName.trim()) {
      errs.signupLastName = true;
    }
    if (!signupUsername.trim()) {
      errs.signupUsername = true;
    }
    if (!signupEmail || !/^\S+@\S+\.\S+$/.test(signupEmail)) {
      errs.signupEmail = true;
    }
    if (!signupPassword) {
      errs.signupPassword = true;
    }
    if (!signupSchool.trim()) {
      errs.signupSchool = true;
    }
    if (!signupMajor.trim()) {
      errs.signupMajor = true;
    }
    if (!signupGradYear) {
      errs.signupGradYear = true;
    }
    setSignupErrors(errs);
    if (Object.keys(errs).length === 0) {
      onSignUp(signupEmail, signupPassword, signupUsername);
    }
  }

  return (
    <div className="container">
      {/* login Form */}
      <form className={`form${!showSignup ? " active" : ""}`} id="login-form" onSubmit={handleLoginSubmit}>
        <h2>[log in]</h2>
        <div className="form-group">
          <label htmlFor="login-email">Email</label>
          <input type="email" id="login-email" name="email" value={loginEmail} onChange={e => setLoginEmail(e.target.value)} aria-invalid={loginErrors.loginEmail} required />
          {loginErrors.loginEmail && <p className="error-message">Please enter a valid email</p>}
        </div>
        <div className="form-group">
          <label htmlFor="login-password">Password</label>
          <input type="password" id="login-password" name="password" value={loginPass} onChange={e => setLoginPass(e.target.value)} aria-invalid={loginErrors.loginPass} required />
          {loginErrors.loginPass && <p className="error-message">Password is required</p>}
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{color: "green"}}>{success}</p>}
        <button type="submit">[log in]</button>
        <div className="switch-form">
          Don't have an account yet?{' '}
          <button type="button" className="link-button" onClick={() => setShowSignup(true)}>
            [sign up]
          </button>
        </div>
      </form>
      {/* Sign Up Form */}
      <form className={`form${showSignup ? " active" : ""}`} id="signup-form" onSubmit={handleSignUpSubmit}>
        <h2>[sign up]</h2>
        <div className="form-group">
          <label htmlFor="firstname">First Name</label>
          <input type="text" id="firstname" name="firstname" value={signupFirstName} onChange={e => setSignupFirstName(e.target.value)} aria-invalid={signupErrors.signupFirstName} required />
          {signupErrors.signupFirstName && <p className="error-message">First name is required</p>}
        </div>
        <div className="form-group">
          <label htmlFor="lastname">Last Name</label>
          <input type="text" id="lastname" name="lastname" value={signupLastName} onChange={e => setSignupLastName(e.target.value)} aria-invalid={signupErrors.signupLastName} required />
          {signupErrors.signupLastName && <p className="error-message">Last name is required</p>}
        </div>
        <div className="form-group">
          <label htmlFor="signup-username">Username</label>
          <input type="text" id="signup-username" name="username" value={signupUsername} onChange={e => setSignupUsername(e.target.value)} aria-invalid={signupErrors.signupUsername} required />
          {signupErrors.signupUsername && <p className="error-message">Username is required</p>}
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" value={signupEmail} onChange={e => setSignupEmail(e.target.value)} aria-invalid={signupErrors.signupEmail} required />
          {signupErrors.signupEmail && <p className="error-message">Please enter a valid email</p>}
        </div>
        <div className="form-group">
          <label htmlFor="signup-password">Password</label>
          <input type="password" id="signup-password" name="password" value={signupPassword} onChange={e => setSignupPassword(e.target.value)} aria-invalid={signupErrors.signupPassword} required />
          {signupErrors.signupPassword && <p className="error-message">Password is required</p>}
        </div>
        <div className="form-group">
          <label htmlFor="school">School</label>
          <input type="text" id="school" name="school" value={signupSchool} onChange={e => setSignupSchool(e.target.value)} aria-invalid={signupErrors.signupSchool} required />
          {signupErrors.signupSchool && <p className="error-message">School is required</p>}
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="major">Major</label>
            <input type="text" id="major" name="major" value={signupMajor} onChange={e => setSignupMajor(e.target.value)} aria-invalid={signupErrors.signupMajor} required />
            {signupErrors.signupMajor && <p className="error-message">Major is required</p>}
          </div>
          <div className="form-group">
            <label htmlFor="grad-year">Graduation Year</label>
            <select id="grad-year" name="grad-year" value={signupGradYear} onChange={e => setSignupGradYear(e.target.value)} aria-invalid={signupErrors.signupGradYear} required>
              <option value="">Select Year</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
            </select>
            {signupErrors.signupGradYear && <p className="error-message">Graduation year is required</p>}
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{color: "green"}}>{success}</p>}
        <button type="submit">[sign up]</button>
        <div className="switch-form">
          Already have an account?{' '}
          <button type="button" className="link-button" onClick={() => setShowSignup(false)}>
            [log in]
          </button>
        </div>
      </form>
    </div>
  );
}

export default LoginPage;
